<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.182 17.8078C13.5725 17.4173 13.5725 16.7841 13.182 16.3936L8.82852 12.0401L13.182 7.6866C13.5725 7.29607 13.5725 6.66291 13.182 6.27239C12.7915 5.88186 12.1583 5.88186 11.7678 6.27239L6.7072 11.333C6.31668 11.7235 6.31668 12.3567 6.7072 12.7472L11.7678 17.8078C12.1583 18.1983 12.7915 18.1983 13.182 17.8078Z"
      fill="currentColor"
    />
  </svg>
</template>
